<template>
  <HvhModal :value="true" :title="modalTitle" max-width="80vw" :isLoading="isUpdating || isLoading" persistent @input="$emit('close')">
    <template v-slot>
      <v-form :class="{ readonly: readOnly }" @input="formValid = $event" ref="form">
        <div class="hvh-flex wrap">
          <v-text-field class="col-12 col-md-6" :disabled="!!formData.id" label="PO #" v-model="formData.orderId" :rules="requiredRules" />
          <div class="col-12 col-md-6 pt-0" :class="{ disabled: formData.id }">
            <HvhDatePicker label="Date" v-model="formData.orderDate" :rules="requiredRules" />
          </div>
        </div>

        <ITMCustomerSearch class="col-12" :disableSearch="!!formData.id" v-model="formData.primaryCustomer" :items="customers" :filterFnc="customerFilter" :textFnc="textFnc" text="Customer" :rules="requiredRules" prop="customerNumber" />
        <ITMCustomerSearch class="col-12" :disableSearch="!!formData.id" v-model="formData.billingCustomer" :items="customers" :filterFnc="customerFilter" :textFnc="textFnc" text="Bill To" prop="customerNumber" />
        <ITMCustomerSearch class="col-12" :disableSearch="!!formData.id" v-model="formData.shippingCustomer" :items="customers" :filterFnc="customerFilter" :textFnc="textFnc" text="Ship To" prop="customerNumber" />

        <div class="hvh-flex align-center col-12">
          <h2>Two Year Commitment</h2>
          <v-icon class="ml-3" medium @click="addCommitment">mdi-plus-box-outline</v-icon>
        </div>
        <div class="hvh-flex" v-for="(commitment, ind) in formData.productsOverview" :key="ind">
          <div class="hvh-flex wrap align-start">
            <div class="hvh-flex wrap col-12 col-md-5 p-0">
              <v-text-field class="col-3" label="Quantity" :disabled="!!formData.id && !!commitment.id" v-model="commitment.quantity" :rules="requiredRules" />
              <v-autocomplete
                class="col-5"
                :disabled="!!formData.id && !!commitment.id"
                :value="commitment.product"
                :items="allProducts"
                item-value="id"
                item-text="name"
                label="Product"
                :rules="requiredRules"
                @input="productSelected(commitment, $event)"
              >
                <template v-slot:item="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>

              <v-text-field class="col-4" :disabled="!!formData.id && !!commitment.id" label="Activity" v-model="commitment.activity" />
            </div>

            <div class="hvh-flex wrap col-12 col-md-7 p-0">
              <div class="hvh-flex wrap grow-1">
                <v-text-field class="col-12 col-sm-6 col-md-3" :disabled="!!formData.id && !!commitment.id" label="Monthly Payment" v-model="commitment.monthlyPayment" :rules="requiredRules" />
                <v-text-field class="col-12 col-sm-6 col-md-3" :disabled="!!formData.id && !!commitment.id" label="Total Cost" v-model="commitment.totalCost" :rules="requiredRules" />
                <div class="col-12 col-md-6 p-0">
                  <div class="hvh-flex wrap" v-for="(delivery, ind) in commitment.orderDeliveries" :key="ind">
                    <div class="col-12 col-sm-6 pt-0">
                      <HvhDatePicker label="Delivery Date" v-model="delivery.fedexDeliveryDate" />
                    </div>
                    <div class="col-12 col-sm-6 pt-0 hvh-flex">
                      <!-- <HvhDatePicker label="Shipment date" v-model="delivery.fedexShippingDate" /> -->
                      <v-text-field label="FedEx Shipment/tracking ID" v-model="delivery.fedexShipmentId" />
                    </div>
                    <div class="col-12 col-sm-6 pt-0 hvh-flex">
                      <v-autocomplete :value="delivery.productStatus.productStatus" :items="productStatus" item-value="id" item-text="name" label="Product Status" :rules="requiredRules" @input="productStatusSelected(delivery, $event)">
                        <template v-slot:item="{ item }">
                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </div>
                    <div class="col-12 col-sm-6 pt-0 hvh-flex">
                      <HvhDatePicker label="Effective Date" v-model="delivery.productStatus.effectiveDate" :rules="requiredRules" />
                    </div>
                  </div>
                  <div class="col-12 pt-0 hvh-flex align-center">
                    Add Delivery
                    <v-icon class="ml-3" medium @click="addDelivery(commitment)">mdi-plus-box-outline</v-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3" :title="canRemoveCommitement(ind, commitment) ? 'Remove' : ''">
            <v-icon :class="{ disabled: !canRemoveCommitement(ind, commitment) }" @click="removeCommitment(commitment)">mdi-close</v-icon>
          </div>
        </div>

        <div class="hvh-flex align-center col-12 pb-0">
          <h2>Documents</h2>
          <v-icon class="ml-3" medium @click="documentForUpload = {}">mdi-plus-box-outline</v-icon>
        </div>
        <ITMDocuments class="col-12" :documents="documents" @remove="removeDocument" />
      </v-form>
      <ITMUploadDocument :value="documentForUpload" :isLoading="isUpdating" @input="addDocument" @close="documentForUpload = null" v-if="documentForUpload">
        <template v-slot:notify-section="{ formData }">
          <div class="col-12 hvh-flex pl-0">
            <input type="checkbox" v-model="notify" id="notify" />
            <label for="notify" class="ml-2">Notify on expiration</label>
          </div>
          <v-select
            class="col-12 pl-0"
            v-model.number="formData.notificationDaysBefore"
            label="Number of days before expiration date to notify:"
            :items="[0, 25, 50, 100]"
            :rules="[(v) => !!v || v === false || v === 0 || 'Field is required']"
            v-if="notify"
          />
        </template>
      </ITMUploadDocument>
    </template>
    <template v-slot:actions>
      <template v-if="!readOnly">
        <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')">Cancel</v-btn>
        <v-btn flat class="hvh-btn hvh-btn--primary" :class="{ disabled: wasValidated && !formValid }" @click="saveData">Save</v-btn>
      </template>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')" v-else>Close</v-btn>
    </template>
  </HvhModal>
</template>

<script>
import HvhModal from '../common/modal/HvhModal.vue';
import cloneDeep from 'clone-deep';
import HvhDatePicker from '../common/form/datePicker/HvhDatePicker.vue';
import { errorDebug, formatDate, toFormData } from '../../libraries/common';
import axios from '../../axios';
import ITMCustomerSearch from './ITMCustomerSearch.vue';
import ITMDocuments from './ITMDocuments.vue';
import ITMUploadDocument from './ITMUploadDocument.vue';
export default {
  components: { HvhModal, HvhDatePicker, ITMCustomerSearch, ITMDocuments, ITMUploadDocument },
  props: ['value', 'isLoading', 'readOnly'],
  data() {
    var requiredRules = [v => !!v || v === false || 'Field is required'];

    var formData = {
      customer: {},
      primaryCustomer: null,
      billingCustomer: null,
      shippingCustomer: null,
      productsOverview: [{
        orderDeliveries: [{
          productStatus: { productStatus: null }
        }],
      }],
      documentations: [],
    };
    return {
      isUpdating: false,
      customers: [],
      products: [],
      formData: { ...formData, ...cloneDeep(this.value) },
      requiredRules,
      numberRules: [
        ...requiredRules,
        v => (v > 0 && parseInt(v) == v) || 'You need to enter positive integer number',
      ],
      wasValidated: false,
      formValid: true,
      documentForUpload: null,
      productStatus: [],
      notify: false
    };
  },
  computed: {
    documents() {
      return (this.formData.documentations || []).filter(f => !f.deleted);
    },
    modalTitle() {
      if (this.readOnly)
        return 'Order Details';
      return this.formData.id ? 'Edit Details' : 'Create Order';
    },
    allProducts() {
      return this.products.any() ? this.products : (this.formData.productsOverview || []).map(f => f.product).filter(f => f);
    },
  },
  methods: {
    formatDate(date) {
      return date && formatDate(date);
    },
    saveData() {
      this.wasValidated = true;
      if (!this.$refs.form.validate()) return;
      this.$emit('input', this.formData);
    },
    addCommitment() {
      this.formData = {
        ...this.formData,
        productsOverview: [
          ...(this.formData.productsOverview || []),
          { orderDeliveries: [{ productStatus: { productStatus: null } }], },
        ]
      };
    },
    removeCommitment(commitment) {
      this.formData = {
        ...this.formData,
        productsOverview: this.formData.productsOverview.filter(f => f !== commitment),
      };
    },
    getCustomers() {
      axios.get('/ITM/Customers/GetCustomers')
        .then(({ data }) => this.customers = data
          .map(f => ({
            id: f.id,
            customerNumber: f.customerNumber,
            facilityName: f.facilityName,
            addressLine1: f.address,
            city: f.city,
            state: f.state,
            zip: f.zip,
            // contactPoc: null,
            email: f.email,
            contactNumber: f.contactNumber,
          }))
        )
        .catch(errorDebug);
    },
    getProducts() {
      axios.get(`/ITM/Products/GetProducts`)
        .then(({ data }) => this.products = data)
        .catch(errorDebug);
    },
    customerSelected(prop, selected) {
      this.formData = {
        ...this.formData,
        [prop]: {
          ...this.formData[prop],
          ...selected,
        },
      };
    },
    customerFilter(item, search) {
      return ['customerNumber', 'facilityName', 'city', 'state', 'zip', 'addressLine1', 'email', 'contactNumber']
        .any(key => item[key]?.toLowerCase().includes(search.toLowerCase()));
    },
    addDocument(event) {
      this.isUpdating = true;
      axios.post(`/api/ITM/Documents`, toFormData(event))
        .then(({ data }) => {
          console.log(data);
          this.formData = {
            ...this.formData,
            documentations: [
              ...(this.formData.documentations || []),
              data,
            ],
          };
          this.documentForUpload = null;
        })
        .catch(errorDebug)
        .then(() => this.isUpdating = false);
    },
    removeDocument(item) {
      this.$confirm('Remove Document', `Are you sure you want to remove document ${item.fileName}?`)
        .then(() => {
          this.formData = {
            ...this.formData,
            documentations: this.formData.documentations.filter(f => f.id !== item.id),
          }
        })
        .catch(() => null);
    },
    textFnc(item) {
      return `${item.customerNumber} - ${item.facilityName} - ${item.city}/${item.state}/${item.zip} - ${item.addressLine1} - ${item.email} - ${item.contactNumber}`;
    },
    productSelected(commitment, event) {
      var product = this.products.find(f => f.id == event);

      this.$set(commitment, 'product', product);
    },
    addDelivery(commitment) {
      this.$set(commitment, 'orderDeliveries', [...commitment.orderDeliveries, {
        productStatus: { productStatus: null }
      }]);
    },
    getProductStatus() {
      axios.get(`/api/ITM/Orders/getproductstatus`)
        .then(({ data }) => this.productStatus = data)
        .catch(errorDebug);
    },
    productStatusSelected(delivery, event) {
      var selectedProductStatus = this.productStatus.find(f => f.id == event);

      this.$set(delivery.productStatus, 'productStatus', selectedProductStatus);
    },
    canRemoveCommitement(ind, commitment) {
      return ind && !commitment.id;
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMCreateOrder'] = this;
    this.getCustomers();
    this.getProducts();
    this.getProductStatus();
  },
}
</script>

<style lang="scss" scoped>
.date-input {
  box-sizing: border-box;
  width: 88px;
  padding: 5px;
  border: 1px solid #b0b3b6;
  background-color: #ffffff;
}
</style>